module.exports = __webpack_public_path__ + "static/media/mobile-app1.3c3928a5.jpg";